import { render, staticRenderFns } from "./CellRendererDetailActions.vue?vue&type=template&id=235a3d34"
import script from "./CellRendererDetailActions.vue?vue&type=script&lang=js"
export * from "./CellRendererDetailActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports